<template>
    <section class="friends">
        <div class="info-block container-mobile">
            <div class="page-loader" v-if="loading">{{ $t("loading.loading") }}</div>

            <div v-if="noContent" class="page-loader">
                {{ noContent }}
                <div>
                    <button class="button" @click="reloadPage" style="margin-top: 22px;">Обновить</button>
                </div>
            </div>
            <div v-if="!noContent && !loading">
                <div class="events-img-wrapper moderation-img">
                    <img :src="image" alt="Изображение модерации" class="events-img" />
                </div>
                <div>
                    <button class="button" @click="approve">Да</button>
                    <button class="button" @click="reject">Нет</button>
                    <input type="text" v-model="comment" class="input" style="margin-top: 22px;"
                        placeholder="Введите комментарий">
                    <div>
                        <button class="button" @click="reloadPage" style="margin-top: 22px;">Обновить</button>
                    </div>
                </div>
            </div>

        </div>
    </section>
</template>

<script>
import ApiService from '@/services/api.service';

export default {
    name: 'Moderation',
    props: {
        i18n: Object,
    },
    data() {
        return {
            ImageModerationSocket: null,
            image: '',
            loading: true,
            comment: '',
            currentImageId: null,
            successMessage: '',
            noContent: ''
        }
    },
    methods: {
        connect() {
            // Подключаемся к WebSocket серверу
            this.ImageModerationSocket = new WebSocket(
                "wss://" + window.location.host + "/ws/image_moderation/"
            );
            //
            // При успешном подключении отправляем запрос на получение изображения
            this.ImageModerationSocket.onopen = () => {
                console.log("WebSockets connection created.");
                this.ImageModerationSocket.send(
                    JSON.stringify({
                        action: "START",
                    })
                );
            };
            // При получении сообщения от сервера обрабатываем его и устанавливаем изображение
            this.ImageModerationSocket.onmessage = (event) => {
                const data = JSON.parse(event.data);
                if (data.data && data.data.message && data.data.message.image) {
                    this.image = data.data.message.image;
                    this.currentImageId = data.data.message.id; // Устанавливаем ID текущего изображения
                    this.loading = false;
                }
                else if (data.data && data.data.message && !data.data.message.image) {
                    this.noContent = "Нет изображений для модерации";
                    this.loading = false;
                }
                else {
                    console.error("Произошла ошибка при получении изображения");
                }
            };
            // При закрытии соединения с сервером пытаемся подключиться снова через 1 секунду
            this.ImageModerationSocket.onclose = (e) => {
                console.log(
                    "Socket is closed. Reconnect will be attempted in 1 second.",
                    e.reason
                );
                setTimeout(() => {
                    if (this.ImageModerationSocket.readyState === WebSocket.CLOSED) {
                        // Проверяем, что соединение закрыто, прежде чем отправлять "action: START"
                        this.connect();
                        this.ImageModerationSocket.send(
                            JSON.stringify({
                                action: "START",
                            })
                        );
                    }
                }, 1000);
            };
        },
        reloadPage() {
            // window.location.reload() для перезагрузки страницы
            window.location.reload();
        },
        approve() {
            // Отправляем запрос на подтверждение изображения
            this.sendVerificationRequest(1);
        },
        reject() {
            // Отправляем запрос на отклонение изображения
            this.sendVerificationRequest(2);
        },
        sendVerificationRequest(conditionType) {
            // Отправляем запрос на подтверждение или отклонение изображения
            if (this.currentImageId === null) {
                console.error("ID изображения не определен.");
                return;
            }
            const requestBody = {
                "id": this.currentImageId,
                "condition_type": conditionType,
                "verified_reason": "",
            };
            // Если выбрано отклонение изображения, то добавляем комментарий
            if (conditionType === 2) {
                requestBody.verified_reason = this.comment;
            }

            ApiService.put(`/photos/verificate_photo/${this.currentImageId}/`, requestBody)
                .then((response) => {
                    if (response.ok) {
                        // this.successMessage = "Запрос успешно отправлен";
                        this.connect(); // Снова отправляем запрос на получение следующего изображения
                        this.ImageModerationSocket.send(
                            JSON.stringify({
                                action: "START"
                            })
                        );
                    } else {
                        // this.successMessage = "Запрос успешно отправлен";
                        this.ImageModerationSocket.send(
                            JSON.stringify({
                                action: "START"
                            })
                        );
                    }
                })
                .catch((error) => {
                    console.error("Произошла ошибка при отправке запроса", error);
                });

        },
    },
    mounted() {
        this.connect();
    },
}
</script>

<style>
.moderation-img {
    width: 482px;
    height: 100%;
}

@media (max-width: 767px) {
    .moderation-img {
        width: 100%;
        height: 100%;
    }
}
</style>
